<template>
  <div class="step step_13"  :class="{'form__step_hidden': step != number}" :aria-labelledby="`step${number}-title`">
    <transition-group tag="div" name="fade" class="transitiongroup" ref="transitiongroup">
      <RadioGroup :key="1" v-model="stepsdata[number][names[0]]" :grid="true" :gridstay="true" :name="names[0]" title="Хотите добавить дополнительные файлы?" :required="true" :values="['Да','Нет']"/>
      <h3 :key="23" v-show="stepsdata[number][names[0]] == 'Да'" class="form__title">Дополнительный файл</h3>
      <Droparea :key="5" v-show="stepsdata[number][names[0]] == 'Да'" v-model="stepsdata[number][names[1]]" :multiple="false" :required="true" :name="names[1]"/>
      <h3 :key="24" v-show="stepsdata[number][names[0]] == 'Да' && stepsdata[number][names[1]]" class="form__title">Дополнительный файл</h3>
      <Droparea :key="6" v-show="stepsdata[number][names[0]] == 'Да' && stepsdata[number][names[1]]" v-model="stepsdata[number][names[2]]" :multiple="false" :required="true" :name="names[2]"/>
    </transition-group>
    <div class="step__filler"></div>

    <div class="form__btns" ref="btns">
      <Btn class="btn_gray" @click.native.prevent="$store.commit('prevStep')">Назад</Btn>
      <Btn @click.native.prevent="$store.commit('nextStep')" :disabled="!filled() || step != number">Далее</Btn>
    </div>
  </div>
</template>

<script>
import Btn from './ui/Btn.vue'
import RadioGroup from './RadioGroup.vue'
import { mapState } from 'vuex'
import Droparea from './Droparea.vue'

export default {
  data: ()=>({
    names: ['addadditionalfiles', 'additionalfile1', 'additionalfile2'],
    timer: undefined
  }),
  components: { Btn, RadioGroup, Droparea },
  props: {
    number: {type: Number, default: 13}
  },
  beforeUpdate(){
    if (this.$el.classList.contains('form__step_hidden')) return
    this.$el.style.setProperty('overflow', 'hidden')
    let height = this.$el.offsetHeight - this.getFadeHeight() + 'px'
    this.$el.style.setProperty('height', height)
    clearTimeout(this.timer)
  },
  updated(){
    this.$nextTick(()=>{
      let height = 
      [...this.$el.querySelectorAll('.transitiongroup>*:not(.fade-leave-active)')]
        .reduce((p,el)=>p + el.offsetHeight, 0)  
      + this.$el.querySelectorAll('.file_upload:not(.complete)').length * 53 
      - this.$el.querySelectorAll('.file.deleting').length * 53 
      + this.$refs.btns.offsetHeight + 'px'
      this.$el.style.setProperty('height', height)
    })
    this.timer = setTimeout(()=>{
      this.$el.style.removeProperty('height')
      this.$el.style.removeProperty('overflow')
    }, 400)
  },  

  methods: {
    getFadeHeight(){
      let sum = 0
      this.$el.querySelectorAll('.fade-leave-active').forEach(el=>sum += el.offsetHeight)
      return sum
    },    
    filled(){
      return  true
    }
  },
  computed: {
    ...mapState(['stepsdata','step']),
  }

}
</script>

<style lang="sass">
.step.step_13
  transition: height .4s ease-out, opacity 0.5s ease
  display: flex
  flex-direction: column
  .form__btns
    position: sticky
    bottom: 0
    z-index: 100

</style>